<template>
    <div class="homework-public-page">
        <el-form label-position="top" ref="form" class="demo-ruleForm">
            <div class="panel">
                <h3 class="panel-title">新建作业</h3>
                <el-form-item prop="course_id" label="班级">
                    <el-select
                      v-model="course_id"
                      filterable
                      remote
                      reserve-keyword
                      loading-text="加载中..."
                      no-match-text="无匹配数据"
                      no-data-text="无数据"
                      placeholder="选择一个班级"
                      @change="onCourseChange"
                      :remote-method="searchCourse"
                      :loading="course_loading">
                      <el-option
                        v-for="item in courseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="lesson_id"  label="授课内容">
                  <el-select
                    v-model="lesson_id"
                    :disabled="!course_id"
                    filterable
                    remote
                    reserve-keyword
                    loading-text="加载中..."
                    no-match-text="无匹配数据"
                    no-data-text="无数据"
                    placeholder="选择一个授课内容"
                    @change="onLessonChange"
                    :remote-method="searchLesson"
                    :loading="lesson_loading">
                    <el-option
                      v-for="item in lessonList"
                      :key="item.id"
                      :label="item.subject"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="task_id"  label="作业">
                  <el-select
                    v-model="task_id"
                    :disabled="!lesson_id"
                    filterable
                    remote
                    reserve-keyword
                    loading-text="加载中..."
                    no-match-text="无匹配数据"
                    no-data-text="无数据"
                    placeholder="选择一个作业"
                    @change="onTaskChange"
                    :remote-method="searchTask"
                    :loading="task_loading">
                    <el-option
                      v-for="item in taskList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
            </div>
            <div class="panel" v-loading="student_loading">
                <h3 class="panel-title">学生</h3>
                <el-checkbox v-if="studentsList.length > 3" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">All Select</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="student" @change="handleCheckedStudentChange">
                    <el-checkbox v-for="item in studentsList" :disabled="publishedMap[item.user_id]" :label="item.user_id" :key="item.user_id">{{item.user_name}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </el-form>
        <div class="buttons">
            <el-button style="width: 120px;height: 120px;border-radius: 50%;" @click="reset">重选</el-button>
            <el-button :loading="publisLoading" type="primary" style="width: 120px;height: 120px;border-radius: 50%;" @click="publish">发布作业</el-button>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      isIndeterminate: false,
      checkAll: false,
      course_id: '',
      lesson_id: '',
      course_loading: false,
      lesson_loading: false,
      task_loading: false,
      studentsList: [],
      taskList: [],
      courseList: [],
      lessonList: [],
      student_loading: false,
      student: [],
      task_id: '',
      publishedMap: {},
      publisLoading: false
    }
  },
  watch: {

  },
  created () {
    this.searchCourse()
    this.$nextTick(() => {
      const { id, lesson_id, task_id } = this.$route.query
      if (id && lesson_id && task_id) {
        this.course_id = +id
        if (id) {
          this.getStudentList()
        }
        this.lesson_id = +lesson_id
        if (lesson_id) {
          this.searchLesson()
        }
        this.task_id = +task_id
        if (task_id) {
          this.searchTask()
        }

        this.searchHomework(task_id)
      }
    })

    // this.searchLesson()
    // this.searchTask()
  },
  methods: {
    onCourseChange (value) {
      if (value) {
        this.searchLesson()
        this.getStudentList()
        this.lesson_id = ''
        this.task_id = ''
      }
    },
    onLessonChange (value) {
      if (value) {
        this.searchTask()
        this.task_id = ''
      }
    },
    onTaskChange (task_id) {
      if (!task_id) return
      this.searchHomework(task_id)
    },
    searchHomework (task_id) {
      this.student_loading = true
      this.$api.tasks
        .homeworks(task_id)
        .then(data => {
          let tmp = {}
          data.forEach(el => {
            tmp[el.student_id] = true
          })
          this.publishedMap = tmp
          this.student_loading = false
        })
        .catch(err => {
          this.student_loading = false
          this.$error(err)
        })
    },
    publish () {
      if (!this.course_id) {
        this.$warning('选择一个班级')
        return
      }
      if (!this.task_id) {
        this.$warning('选择一个作业')
        return
      }
      if (this.student.length == 0) {
        this.$warning('选择学生')
        return
      }
      this.publisLoading = true
      this.$api.tasks.start(this.task_id, this.student).then(data => {
        this.publisLoading = false
        this.$success('发布成功!')
        this.reset()
      }).catch(err => {
        this.$error(err)
        this.publisLoading = false
      })
    },
    reset () {
      if (!this.$route.query.id) {
        this.course_id = ''
        this.lesson_id = ''
        this.task_id = ''
        this.studentsList = []
      }
      this.student = []
    },
    getStudentList () {
      this.$api.courses
        .students({ id: this.course_id, page: 1, per_page: 100 })
        .then(data => {
          this.total = data.total
          this.studentsList = data.data
        })
        .catch(err => {
          this.$error(err)
        })
    },
    searchCourse (name) {
      this.course_loading = true
      this.$api.courses
        .list({ fields: ['id', 'name'], page: 1, per_page: 100, name })
        .then(data => {
          this.courseList = data.data
          this.course_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.course_loading = false
        })
    },
    searchLesson (subject) {
      if (!this.course_id) {
        this.$warning('选择一个班级')
        return
      }
      this.lesson_loading = true
      this.$api.courses
        .lessons({
          id: this.course_id,
          fields: ['id', 'subject'],
          page: 1,
          per_page: 100,
          subject
        })
        .then(data => {
          this.lessonList = data
          this.lesson_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.lesson_loading = false
        })
    },
    searchTask (name) {
      if (!this.course_id) {
        this.$warning('选择一个班级')
        return
      }
      if (!this.lesson_id) {
        this.$warning('选择一个课程')
        return
      }
      this.task_loading = true
      this.$api.tasks
        .list({
          lesson_id: this.lesson_id,
          page: 1,
          per_page: 100,
          name
        })
        .then(data => {
          this.taskList = data.data
          this.task_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.task_loading = false
        })
    },
    handleCheckAllChange (val) {
      this.student = val ? this.studentsList.map(el => el.user_id) : []
      this.isIndeterminate = false
    },
    handleCheckedStudentChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.studentsList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.studentsList.length
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.homework-public-page {
  .el-form {
    display: flex;
    justify-content: space-between;
    .panel {
      width: calc(50% - 55px);
      border: 1px solid #ccc;
      border-radius: 5px;
      padding: 20px;
      .el-select {
        width: 100%;
      }
    }
    .el-checkbox {
      display: block;
      margin: 10px 0;
    }
    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
  .buttons{
    display: flex;
    justify-content: space-around;
    margin: 30px 10%;
  }
}
</style>
